<template>
    <d2-container :filename="filename">
        <template slot="header">
            <el-badge :value="data.length" class="item">
                <el-breadcrumb separator="/" style="font-size: 20px;margin:10px;">
                    <el-breadcrumb-item>
                        <a  @click="ShowFile('')" >根目录</a>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item v-for="item in Paths">
                        <a @click="ShowFile(item.value)" v-text="item.key"></a>
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </el-badge>
        </template>
        <el-table
                v-loading="loading"
                :data="data"
                stripe
                style="width: 100%">
            <el-table-column
                    prop="icon"
                    label=""
                    width="35">
                <template slot-scope="scope">
                    <d2-icon v-if="scope.row.class==='file'" name="file-text-o"></d2-icon>
                    <d2-icon v-else name="folder"></d2-icon>
                </template>
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="文件名">
                <template slot-scope="scope">
                    <span v-if="scope.row.class==='file'" v-text="scope.row.name"></span>
                    <a @click="ShowFile(nowpath+scope.row.name+'/')" v-else v-text="scope.row.name"></a>
                </template>
            </el-table-column>
            <el-table-column
                    prop="size"
                    label="大小">
            </el-table-column>
            <el-table-column
                    prop="view"
                    label="查看">
                <template slot-scope="scope">
                    <el-button @click="VieFile(scope.row.name)">查看</el-button>
                </template>
            </el-table-column>
            <!--<el-table-column-->
            <!--prop="do"-->
            <!--label="操作">-->
            <!--<template slot-scope="scope">-->
            <!--<el-button type="primary" @click="view(scope.row.file)">查看</el-button>-->
            <!--<el-button type="danger" @click.native.prevent="deleteRow(scope.$index, data)"-->
            <!--:disabled="scope.row.use">删除-->
            <!--</el-button>-->
            <!--</template>-->
            <!--</el-table-column>-->
        </el-table>
        <el-dialog
                title=""
                :visible.sync="dialogVisible"
                width="30%" style="text-align: center">
            <img :src="'//cdn.heanny.cn/Blog/'+imgurl" alt="" style="max-width:100%;margin: 0 auto">
            <span slot="footer" class="dialog-footer">
              </span>
        </el-dialog>
    </d2-container>
</template>

<script>
    export default {
        data() {
            return {
                filename: __filename,
                Paths: [],
                data: [],
                dialogVisible: false,
                loading: false,
                imgurl: '',
                path: '',
                nowpath: ''
            }
        },
        methods: {
            getData() {
                this.loading = true
                this.$request({
                    url: "getFile.do",
                    data: {
                        path: this.path,
                    }
                    // method: 'get',
                    // data: {
                    //     path:this.path
                    //     // action: '',
                    //     // action: 'getUserImgs',
                    // }
                }).then(res => {
                    const _this = this
                    const PathAaa = []
                    Object.keys(res.paths).forEach(function (key) {
                        PathAaa.push({'key': key, 'value': res.paths[key]});
                    });
                    this.Paths = PathAaa
                    this.loading = false
                    this.data = res.files
                    this.nowpath = res.path
                }).catch((error) => {
                    this.msg = error
                    this.loading = false
                })
            },
            ShowFile(path) {
                this.path = (path)
                this.getData()
            },
            VieFile(file){
                this.$store.dispatch('d2admin/page/open', {
                    name: 'heannyByUrl',
                })
                location.href = '/#/heanny/'+encodeURIComponent("//www.heanny.cn/"+ this.nowpath.replace('../','')+file)
                // window.open("http://www.heanny.cn/"+ this.nowpath.replace('../','')+file,"_block");
            },
            view(file) {
                this.imgurl = file
                this.dialogVisible = true
            },
            deleteRow(index, rows) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$request({
                        url: 'imgFile.php',
                        method: 'post',
                        data: {action: 'delFile', file: rows[index].file, type: 'Blog'}
                    }).then(res => {
                        rows.splice(index, 1);
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },

        },
        created: function () {
            this.getData()
        }
    }
</script>
<style>
    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
</style>
